import { memo } from 'react'
import { MenuItem, MenuSection, Typography } from '@getgo/chameleon-web-react-wrapper'
import { Box } from '@material-ui/core'
import mixpanel from 'mixpanel-browser'

import { PartnerMenuItem } from 'types/PartnerMenuItem'
import { mixpanelEventNames } from 'utils'

interface PartnerTools {
  links: PartnerMenuItem[]
  title: string
}

const PartnerToolsDrawerSection = ({ links, title }: PartnerTools): JSX.Element => {
  return (
    <>
      <MenuSection>
        <Typography variant="body-medium-strong">{title}</Typography>
      </MenuSection>
      <Box pt={2} pb={2}>
        {links.map(({ key, title, href }) => (
          <MenuItem
            key={key}
            onClick={() => {
              mixpanel.track(mixpanelEventNames.PARTNER_TOOLS_DRAWER, {
                Action: `Navigated to ${key}`,
              })
              window.open(href, '_blank')
            }}
          >
            {title}
          </MenuItem>
        ))}
      </Box>
    </>
  )
}

export default memo(PartnerToolsDrawerSection)
